import React from 'react';
import { Icon } from '@frontend/icons';
import { Text } from '../../text';
import { ActionPressedChip } from '../atoms';
import { flexCenter } from '../common-styles';

type UnderlineActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const UnderlineAction = ({ compact = true, showBoxShadow = true, ...rest }: UnderlineActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <Text as='span' className={flexCenter}>
        <Icon name='underline-small' />
      </Text>
    </ActionPressedChip>
  );
};
